var map = {
	"./AAPL.svg": 23072,
	"./ADA.png": 46056,
	"./AMZN.png": 8768,
	"./AMZN.svg": 84464,
	"./ARB.png": 62825,
	"./BNB.png": 20554,
	"./BTC.png": 98673,
	"./DOGE.png": 6985,
	"./ETH.jpg": 36717,
	"./FTT.png": 40090,
	"./GOOGL.svg": 99678,
	"./LINK.jpg": 91014,
	"./MSFT.svg": 87412,
	"./NETTF.svg": 19417,
	"./NVIDIA.svg": 30627,
	"./QABA.png": 99619,
	"./SLQD.png": 72228,
	"./SOHU.svg": 44685,
	"./SOL.png": 34910,
	"./UNI.png": 83842,
	"./XRP.png": 96358,
	"./aud.png": 58466,
	"./chf.png": 33433,
	"./cny.svg": 62402,
	"./eur.png": 67032,
	"./fund-02800.svg": 63622,
	"./fund-02823.svg": 60939,
	"./fund-02828.svg": 66432,
	"./fund-02840.svg": 80522,
	"./fund-03033.svg": 91003,
	"./fund-03037.svg": 29447,
	"./fund-03067.svg": 2992,
	"./fund-03188.svg": 40808,
	"./gbp.png": 72557,
	"./hkd.png": 87581,
	"./jin.svg": 86561,
	"./jpy.png": 54751,
	"./krw.svg": 73792,
	"./qy.svg": 34684,
	"./trq.svg": 89709,
	"./tsl.svg": 59851,
	"./usdthb.png": 45692,
	"./wangyi.png": 71449,
	"./xau.png": 80634,
	"./yc.png": 73410,
	"./yin.svg": 99658,
	"./yingweida.png": 37173,
	"./you.svg": 75387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47604;